import axios from './axios'

export const startPayment = async (locale, subscriptionType, israel) => {
  const { data } = await axios.get(
    `/pay/start-payment/${locale}?id=${subscriptionType}&israel=${israel}`
  )
  return { token: data.token, url: data.url }
}

export const cancelPayment = async paymentPublicId => {
  await axios.delete(`/pay/cancel-payment?paymentPublicId=${paymentPublicId}`)
}
